export const SERVICE_DETAILS='SERVICE_DETAILS';